import type { Project, ProjectSummary } from '@/types/project';

export const LEGACY_OPERATION_TEMPLATE_PROJECT_NAME = 'operation-toy-plant';

export function isHiddenLegacyProject(
  project: Pick<Project | ProjectSummary, 'name' | 'description'>,
): boolean {
  return (
    project.name === LEGACY_OPERATION_TEMPLATE_PROJECT_NAME &&
    (project.description?.includes('[template:') ?? false)
  );
}
